import React from 'react';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  text: string;
  subtext?: string;
  className?: string;
  fullWidth?: boolean;
}
export const CTAButton: React.FC<CTAButtonProps> = ({
  text,
  subtext,
  className = '',
  fullWidth = false
}) => {
  const checkoutUrl = 'https://pagos.kaisen.studio/checkouts/cn/hWN8AiqKXRB3k2sBJ6hApo6U/es-ar?_r=AQABbpE6sJ9qWEsj7QWKmo70VRor1UlUm2k3lthQRpsjn9A&cart_link_id=hFHkHqTX&preview_theme_id=143515418726';
  return <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className={`
        group relative flex flex-col items-center justify-center 
        bg-[#22c55e] hover:bg-[#16a34a] text-white 
        py-4 px-8 rounded-lg shadow-xl hover:shadow-2xl hover:-translate-y-1
        transition-all duration-300 ease-in-out cursor-pointer
        border-b-4 border-[#15803d] active:border-b-0 active:translate-y-1
        ${fullWidth ? 'w-full' : 'w-auto'}
        ${className}
      `} data-id="element-1">
      <div className="flex items-center gap-2 text-xl md:text-2xl font-bold uppercase tracking-wide text-center" data-id="element-2">
        {text}
        <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-3" />
      </div>
      {subtext && <span className="text-sm md:text-base opacity-90 font-medium mt-1" data-id="element-4">
          {subtext}
        </span>}
    </a>;
};